import { globalSearchIDs } from '../../../Analytics/testIDConfig';
import { LeagueTypeIds } from '../../../../utils/types';

const { ADULT_TEAM_TENNIS, JUNIOR_TEAM_TENNIS, ADULT_TEAM_PICKLEBALL, JUNIOR_TEAM_PICKLEBALL } = LeagueTypeIds;

export const PlayersNavItemV2 = {
    label: 'Players',
    entityType: 'players',
    testId: `${globalSearchIDs.players.component}-${globalSearchIDs.players.location}-${globalSearchIDs.players.id}`,
    filterType: 'players',
    sportType: {
        showTennisContent: true,
        showPickleballContent: true,
    },
};

export const EventsNavItemV2 = {
    label: 'Events',
    entityType: 'events',
    testId: `${globalSearchIDs.events.component}-${globalSearchIDs.events.location}-${globalSearchIDs.events.id}`,
    filterType: 'events',
    sportType: {
        showTennisContent: true,
        showPickleballContent: true,
    },
};

export const ClubsNavItemV2 = {
    label: 'Clubs',
    entityType: 'clubs',
    testId: `${globalSearchIDs.clubs.component}-${globalSearchIDs.clubs.location}-${globalSearchIDs.clubs.id}`,
    filterType: 'clubs',
    sportType: {
        showTennisContent: true,
        showPickleballContent: true,
    },
};

export const CollegesNavItemsV2 = {
    label: 'Colleges',
    entityType: 'colleges',
    testId: `${globalSearchIDs.colleges.component}-${globalSearchIDs.colleges.location}-${globalSearchIDs.colleges.id}`,
    filterType: 'colleges',
    sportType: {
        showTennisContent: true,
        showPickleballContent: false,
    },
};

export const HighSchoolsNavItemsV2 = {
    label: 'High Schools',
    entityType: 'high schools',
    testId: `${globalSearchIDs.highSchools.component}-${globalSearchIDs.highSchools.location}-${globalSearchIDs.highSchools.id}`,
    filterType: 'highSchools',
    sportType: {
        showTennisContent: true,
        showPickleballContent: false,
    },
};

export const GlobalSearchTennisNavItemsV2 = [
    {
        label: 'UTR Pro Tennis Tour',
        entityType: 'Pro Tennis events',
        testId: `${globalSearchIDs.utrProTennisTour.component}-${globalSearchIDs.utrProTennisTour.location}-${globalSearchIDs.utrProTennisTour.id}`,
        filterType: 'proTennisTour',
        sportType: {
            showTennisContent: true,
            showPickleballContent: false,
        },
    },
    {
        label: 'Flex Leagues',
        entityType: 'Flex League events',
        testId: `${globalSearchIDs.flexLeagues.component}-${globalSearchIDs.flexLeagues.location}-${globalSearchIDs.flexLeagues.id}`,
        filterType: 'flexLeagues',
        sportType: {
            showTennisContent: true,
            showPickleballContent: false,
        },
    },
    {
        label: 'Team Tennis',
        entityType: 'Team Tennis',
        testId: `${globalSearchIDs.teamTennis.component}-${globalSearchIDs.teamTennis.location}-${globalSearchIDs.teamTennis.id}`,
        filterType: [ADULT_TEAM_TENNIS, JUNIOR_TEAM_TENNIS],
        sportType: {
            showTennisContent: true,
            showPickleballContent: false,
        },
        isLeagues: true,
    },
    {
        label: 'College Circuits',
        entityType: 'College Circuits',
        testId: `${globalSearchIDs.collegeCircuits.component}-${globalSearchIDs.collegeCircuits.location}-${globalSearchIDs.collegeCircuits.id}`,
        filterType: 'collegeCircuits',
        sportType: {
            showTennisContent: true,
            showPickleballContent: false,
        },
    },
    {
        label: 'Junior Circuits',
        entityType: 'Junior Circuits',
        testId: `${globalSearchIDs.juniorCircuits.component}-${globalSearchIDs.juniorCircuits.location}-${globalSearchIDs.juniorCircuits.id}`,
        filterType: 'juniorCircuits',
        sportType: {
            showTennisContent: true,
            showPickleballContent: false,
        },
    },
    {
        label: 'Camps',
        entityType: 'Camps',
        testId: `${globalSearchIDs.camps.component}-${globalSearchIDs.camps.location}-${globalSearchIDs.camps.id}`,
        filterType: 'camps',
        sportType: {
            showTennisContent: true,
            showPickleballContent: false,
        },
    },
];

export const GlobalSearchPickleballNavItemsV2 = [
    {
        label: 'All Pickleball Events',
        entityType: 'All pickleball events',
        testId: `${globalSearchIDs.events.component}-${globalSearchIDs.events.location}-${globalSearchIDs.events.id}`,
        filterType: 'events',
        sportType: {
            showTennisContent: false,
            showPickleballContent: true,
        },
    },
    {
        label: 'Flex Leagues',
        entityType: 'Flex League events',
        testId: `${globalSearchIDs.flexLeagues.component}-${globalSearchIDs.flexLeagues.location}-${globalSearchIDs.flexLeagues.id}`,
        filterType: 'flexLeagues',
        sportType: {
            showTennisContent: false,
            showPickleballContent: true,
        },
    },
    {
        label: 'Team Pickleball',
        entityType: 'Team Pickleball',
        testId: `${globalSearchIDs.teamPickleball.component}-${globalSearchIDs.teamPickleball.location}-${globalSearchIDs.teamPickleball.id}`,
        filterType: [ADULT_TEAM_PICKLEBALL, JUNIOR_TEAM_PICKLEBALL],
        sportType: {
            showTennisContent: false,
            showPickleballContent: true,
        },
        isLeagues: true,
    },
];
